import React, { useEffect, useRef } from 'react'
import echarts from './echarts-lib'
import { EChartProps } from './EChart.types'
import { toChartPixelHeight } from '../chartTheme'

const EChartComponent = (props: EChartProps) => {
  const {
    option,
    width = '100%',
    height,
    className,
    style
  } = props

  const containerRef = useRef<HTMLDivElement>(null)
  const chartRef = useRef<any>()
  const resolvedHeight = toChartPixelHeight(height)
  const fillParent = resolvedHeight === '100%'

  useEffect(() => {
    const el = containerRef.current
    if (!el) return

    const chart = echarts.init(el)
    chartRef.current = chart

    const resize = () => {
      chart.resize()
    }

    window.addEventListener('resize', resize)
    let observer: ResizeObserver
    if (typeof ResizeObserver !== 'undefined') {
      observer = new ResizeObserver(resize)
      observer.observe(el)
    }

    return () => {
      window.removeEventListener('resize', resize)
      if (observer) observer.disconnect()
      chart.dispose()
      chartRef.current = undefined
    }
  }, [])

  useEffect(() => {
    if (!chartRef.current || !option) return
    chartRef.current.setOption(option, true)
    chartRef.current.resize()
  }, [option])

  return (
    <div
      ref={containerRef}
      className={className}
      style={{
        width: fillParent ? '100%' : width,
        height: resolvedHeight,
        position: fillParent ? 'absolute' : undefined,
        top: fillParent ? 0 : undefined,
        right: fillParent ? 0 : undefined,
        bottom: fillParent ? 0 : undefined,
        left: fillParent ? 0 : undefined,
        ...style
      }}
    />
  )
}

const EChart = EChartComponent
export { EChart }
